import React from "react";
import StaffMemberCard from "./components/StaffMemberCard";
import samuel from "./assets/samuel.jpg";
import jeremy from "./assets/jeremy.jpg";
import ashley from "./assets/ashley.jpg";
import mark from "./assets/mark.jpg";
import finlay from "./assets/finlay.jpg";
import louis from "./assets/louis.jpg";
import daniel from "./assets/daniel.jpg";
import george from "./assets/george.jpg";
import natalia from "./assets/natalia.jpg";

const teamMembers = [
  {
    name: "Sam Munday",
    role: "Director",
    bio: "Sam drives the strategic direction of Data Revival. He cultivates a team culture built on experimentation and forward momentum.",
    image: samuel,
    alt: "Sam Munday",
    social: {
      linkedin: "https://www.linkedin.com/in/samuel-munday/",
      email: "sam@data-revival.com",
    },
  },
  {
    name: "Prof. Jeremy Frey",
    role: "Director",
    bio: "Jeremy brings decades of experience at the intersection of chemistry and information systems, and his collaborations with academia help bridge frontier research with industry relevance.",
    image: jeremy,
    alt: "Prof. Jeremy Frey",
    social: {
      linkedin: "https://www.linkedin.com/in/jeremygfrey/",
      email: "jeremy@data-revival.com",
    },
  },
  {
    name: "Ashley Unitt",
    role: "Advisor",
    bio: "Ashley applies his experience in scaling tech ventures to help Data Revival navigate startup dynamics, define market fit, and unlock strategic opportunities.",
    image: ashley,
    alt: "Ashley Unitt",
    social: {
      linkedin: "https://www.linkedin.com/in/ashleyunitt/",
      email: "ashley@data-revival.com",
    },
  },
  {
    name: "Mark Goulding",
    role: "Advisor",
    bio: "Mark lends his expertise in enterprise technology and growth strategy to help Data Revival build systems that are as robust as they are visionary. His insights help align technical infrastructure with business outcomes.",
    image: mark,
    alt: "Mark Goulding",
    social: {
      linkedin: "https://www.linkedin.com/in/markjgoulding/",
      email: "mark@data-revival.com",
    },
  },
  {
    name: "Finlay Morrison",
    role: "Lead Data Scientist",
    bio: "Finlay leads the design of cutting-edge machine learning pipelines at Data Revival. His work focuses on optimising model performance and deploying scalable APIs that extract signal from noisy, high-dimensional chemical datasets.",
    image: finlay,
    alt: "Finlay Morrison",
    social: {
      linkedin: "https://www.linkedin.com/in/finlay-morrison/",
      email: "finlay@data-revival.com",
    },
  },
  {
    name: "Louis McLean",
    role: "AI Engineer",
    bio: "Louis engineers the AI foundations that power Data Revival's platform. From LLM systems to special-purpose models, he brings theory into practice.",
    image: louis,
    alt: "Louis McLean",
    social: {
      linkedin: "https://www.linkedin.com/in/louis-mclean-62293b286",
      email: "louis@data-revival.com",
    },
  },
  {
    name: "George Giamouridis",
    role: "Software Engineer",
    bio: "George is a full-stack software engineer with experience in building scalable web platforms. He is currently leading the development of Data Revival, responsible for designing the architecture, implementing core features, and overseeing the platform's development.",
    image: george,
    alt: "George Giamouridis",
    social: {
      linkedin: "https://www.linkedin.com/in/ggiamou/",
      email: "george@data-revival.com",
    },
  },
  {
    name: "Daniel Cançado",
    role: "Senior Data Steward",
    bio: "Daniel builds and optimizes the data infrastructure at the heart of Data Revival. His expertise spans data curation, labeling strategy, and labelling pipelines, designed to handle the unique challenges of scientific data at scale.",
    image: daniel,
    alt: "Daniel Cançado",
    social: {
      linkedin: "https://www.linkedin.com/in/daniel-tomas-c/",
      email: "daniel@data-revival.com",
    },
  },
  {
    name: "Natalia Witkowska",
    role: "Data Steward",
    bio: "Natalia's work focuses on in-depth data validation, curating detailed analyses of data outputs and collaborating with the team to utilise this knowledge to constantly improve outputs. She also helps with data labelling, applying her Chemistry knowledge in this area.",
    image: natalia,
    alt: "Natalia Witkowska",
    social: {
      linkedin: "https://www.linkedin.com/in/natalia-witkowska-5aa299375/",
      email: "natalia@data-revival.com",
    },
  },
];

const About: React.FC = () => {
  return (
    <div className="bg-dark-bg min-h-screen">
      <div className="container mx-auto w-full max-w-5xl px-5 md:px-0 text-center">
        <h1 className="text-5xl md:text-[3.5rem] leading-none font-semibold pt-[10%]">
          <span className="bg-gradient-text bg-clip-text text-transparent">
            Meet the Team
          </span>
        </h1>

        <p className="mt-6 text-white text-lg max-w-3xl mx-auto leading-relaxed">
          We're a passionate team of scientists, engineers, and innovators
          dedicated to unlocking the hidden potential in chemical archives. Our
          diverse expertise in chemistry, AI, and software engineering drives us
          to create breakthrough solutions that transform how researchers access
          and utilise their data.
        </p>
      </div>

      <section className="mt-20 pb-16">
        <div className="container mx-auto w-full max-w-6xl px-5 md:px-0">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {teamMembers.map((member, index) => (
              <StaffMemberCard key={index} member={member} />
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
